module.exports = __webpack_public_path__ + "assets/lessons/en/audio/Audio 3.pdf";